// test2899
(2899 && 0);
